import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { theme } from "../../utils";
import TransMessage from './transMessage';
import { useAppContext } from "../../contexts";
import { InformationCard } from "./components/InformationCard";
import { BackdropComponent, BreadCrumb } from "../../components";
import { modifyInfoData, modifyPracticeInfoData } from "./profile.helper";
import { EditPersonalInfo, EditProfessionalInfo, EditPracticeInfo } from "./editProfile";
import { getPracticeInfoURL, getProfessionalInfoURL, getQueryData, withCredentials } from "../../services";

const styles = {
    pageTitle: {
        ...theme.typography.opticianBodyRegular,
        mt: "8px",
        textAlign: "left",
        fontSize: "28px"
    },
    infoCardWrapper: {
        display: "flex",
        flex: 1,
        gap: "1rem",
        flexWrap: "wrap"
    }
}

const path = [
    { url: '/home', name: 'Home' },
    { url: '/profile', name: 'Profile' }
]
export const Profile = () => {
    const { t } = useTranslation();
    const { providerId } = useAppContext()
    const [mainData, setMainData] = useState<any>({})
    const [practiceInfo, setPracticeInfo] = useState<any>({})
    const [dialogType, setDialogType] = useState<string | null>(null)

    const { data: detailData, isLoading: isInfoLoading } = useQuery("detailsData", async () =>
        getQueryData(getProfessionalInfoURL(providerId), withCredentials()),
        { enabled: dialogType === null }
    );

    const { data: practiceData, isLoading: isPracticeLoading } = useQuery("practiceDetailsData", async () =>
        getQueryData(getPracticeInfoURL(providerId), withCredentials()),
        { enabled: !!providerId && dialogType === null }
    );

    useEffect(() => {
        window.scrollTo(0, 0)
        if (detailData?.data) {
            const modifiedData = modifyInfoData(detailData?.data)
            setMainData(modifiedData)
        }
    }, [detailData])

    useEffect(() => {
        if (practiceData?.data?.length > 0) {
            const modifiedPracticeData = modifyPracticeInfoData(practiceData?.data[0])
            setPracticeInfo(modifiedPracticeData)
        }
    }, [practiceData])

    const handleClose = () => {
        setDialogType(null)
    }

    const renderDialogBox = () => {
        if (dialogType === "personal") {
            return <EditPersonalInfo isVisible={!!dialogType} onCloseDialog={handleClose} data={detailData?.data} />
        }
        else if (dialogType === "professional") {
            return <EditProfessionalInfo isVisible={!!dialogType} onCloseDialog={handleClose} data={detailData?.data} />
        }
        else if (dialogType === "practice") {
            return <EditPracticeInfo isVisible={!!dialogType} onCloseDialog={handleClose} data={practiceData?.data[0]} />
        }
        else {
            return null
        }
    }

    return (
        <Box py="30px" px="3.5rem" mt="35px">
            <Box>
                <BreadCrumb breadCrumbPath={path} />
                <Typography sx={styles.pageTitle}>{t(TransMessage.PROFILE_PAGE_TITLE)}</Typography>
            </Box>
            {renderDialogBox()}
            <Box sx={styles.infoCardWrapper}>
                <InformationCard titleCard={t(TransMessage.PERSONAL_TITLE)} itemData={mainData?.personalInfo} handleEditClick={() => setDialogType("personal")} />
                <InformationCard titleCard={t(TransMessage.PROFESSIONAL_TITLE)} itemData={mainData?.professionalInfo} handleEditClick={() => setDialogType("professional")} />
                <InformationCard titleCard={t(TransMessage.PRACTICE_TITLE)} itemData={practiceInfo} handleEditClick={() => setDialogType("practice")} />
            </Box>
            <BackdropComponent showBackdrop={isInfoLoading || isPracticeLoading} />
        </Box>
    )
}